import axios from "axios";
import { store } from "../Redux/store";

export const local_server = "https://api.leased.homes/index.php/api/v1"
// export const local_server = "http://localhost:8000/api/v1"
// let live_server = "https://api.leased.homes/index.php/api/v1"

const HOSTNAME = local_server;

const callPrivateApi = (endpoint, method, payload) => {
    let token = store.getState().userAuth?.loginInfo?.token || store.getState().userAuth?.GustloginInfo?.token;
    const configaxios = {
        method,
        url: `${HOSTNAME}${endpoint}`,
        data: payload,
        headers: {
            Accept: "application/json",
            "Access-Control-Allow-Origin": " GET, POST, PUT, PATCH, POST, DELETE, OPTIONS",
            "Access-Control-Allow-Headers": "Content-Type",
            "Access-Control-Max-Age": "6000",
            "Access-Control-Allow-Headers": "*",
            token,
        },
    };
    return new Promise((resolve, reject) => {
        axios(configaxios)
            .then((res) => {
                resolve(res.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const callPrivateApiQrCode = (endpoint, method) => {
    let token = store.getState().userAuth?.loginInfo?.token || store.getState().userAuth?.GustloginInfo?.token;
    const configaxios = {
        method,
        url: `${HOSTNAME}${endpoint}`,
        headers: {
            "Content-Type": "application/json",
            Accept: "image/png,image/*",
            token,
        },
        responseType: "arraybuffer", // Set the response type to arraybuffer for binary data
    };
    return new Promise((resolve, reject) => {
        axios(configaxios)
            .then((res) => {
                resolve(res.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const callPublicApi = (endpoint, method, payload) => {
    const HOSTNAME = local_server;
    const configaxios = {
        method,
        url: `${HOSTNAME}${endpoint}`,
        data: payload,
        headers: {
            Accept: "application/json",
            "Access-Control-Allow-Origin": " GET, POST, PUT, PATCH, POST, DELETE, OPTIONS",
            " Access-Control-Allow-Headers": "Content-Type",
            "Access-Control-Max-Age": "6000",
            "Access-Control-Allow-Headers": "*",
        },
    };
    return new Promise((resolve, reject) => {
        axios(configaxios)
            .then((res) => {
                resolve(res.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export { callPublicApi, callPrivateApi, callPrivateApiQrCode ,  HOSTNAME };
